import "./scss/custom";
import $ from "jquery";
import popper from "popper.js";
import bootstrap from "bootstrap";
import * as d3 from "d3";
import "intersection-observer";
import scrollama from "scrollama";
import queryString from "query-string";
import {
  HOME_STEPS_1_URL,
  HOME_STEPS_2_URL,
  HOME_PAGE_URL,
  HOME_STAKEHOLDERS_URL,
  HOME_RISKS_URL,
  HOME_AREAS_URL
} from "./const";
import homeStepsFactory from "./homeSteps";
import homeSteps2Factory from "./homeSteps2";
import homePageFactory from "./homePage";
import homeStakeholdersFactory from "./homeStakeholders";
import homeRisksFactory from "./homeRisks";
import homeAreasFactory from "./homeAreas";

Promise.all([
  d3.tsv(HOME_PAGE_URL),
  d3.tsv(HOME_STEPS_1_URL),
  d3.tsv(HOME_STAKEHOLDERS_URL),
  d3.tsv(HOME_RISKS_URL),
  d3.tsv(HOME_AREAS_URL),
  d3.tsv(HOME_STEPS_2_URL)
]).then(
  ([
    home_page,
    home_steps,
    home_stakeholders,
    home_risks,
    home_areas,
    home_steps_2
  ]) => {
    d3.select(".spinner")
      .transition()
      .style("opacity", "0")
      .on("end", function() {
        d3.select(this).remove();
      });

    const homePage = homePageFactory("body");

    homePage.data(home_page);
    homePage();

    const homeSteps = homeStepsFactory("body");

    homeSteps.data(home_steps);
    homeSteps();

    const homeRisks = homeRisksFactory("body");

    homeRisks.data(home_risks);
    // .on("shown", function(d) {
    //   console.log(d);
    // })
    // .on("hidden", function() {
    //   console.log("hide");
    // });

    homeRisks();

    const homeSteps2 = homeSteps2Factory("body");

    homeSteps2.data(home_steps_2);
    homeSteps2();

    const homeStakeholders = homeStakeholdersFactory("body");

    homeStakeholders.data(home_stakeholders);
    homeStakeholders();

    const homeAreas = homeAreasFactory("body");

    homeAreas.data(home_areas);
    homeAreas();

    // instantiate the scrollama
    const scroller = scrollama();

    function handleStepEnter(d) {
      if (d.index > 0) {
        d3.select("#home-navbar").classed("navbar-show", true);
      } else {
        d3.select("#home-navbar").classed("navbar-show", false);
      }
      const element = d3.select(d.element);

      if (element.classed("homeSteps")) {
        d3.select("#header-title").text("01. introduction");
      } else if (
        element.classed("homeRisks") ||
        element.classed("homeSteps2")
      ) {
        d3.select("#header-title").text("02. risks");
      } else if (element.attr("id") == "areas") {
        d3.select("#header-title").text("03. areas");
      }

      if (element.attr("id") == "areas") {
        element.classed("enter", true);
      }
    }

    function handleStepExit(d) {
      const element = d3.select(d.element);
      if (element.attr("id") == "areas") {
        element.classed("enter", false);
      }
    }

    // setup the instance, pass callback functions
    scroller
      .setup({
        step: ".step",
        debug: false
      })
      .onStepEnter(handleStepEnter)
      .onStepExit(handleStepExit);

    const search = queryString.parse(location.search);
    if (search.q) {
      document.getElementById(search.q).scrollIntoView();
    }

    let eventTimeout;
    const eventHandler = function() {
      scroller.resize();
    };

    const eventThrottler = function() {
      if (!eventTimeout) {
        eventTimeout = setTimeout(function() {
          eventTimeout = null;
          eventHandler();
        }, 100);
      }
    };

    window.addEventListener("resize", eventThrottler, false);
  }
);
